// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__7j2QO","large":"styles_large__1NSiD"};